import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AlertTriangle, CheckCircle2, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { SiteNav } from "@/components/SiteChrome";

export default function GapDraft() {
  const { token } = useParams();
  const [state, setState] = useState({ phase: "working" });
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.post(`/kb-gaps/draft-by-link/${token}`)
      .then((r) => setState({ phase: "done", ...r.data }))
      .catch((e) => setState({ phase: "error", message: errMsg(e) }));
  }, [token]);

  return (
    <div className="min-h-screen bg-background">
      <SiteNav />
      <main className="max-w-xl mx-auto px-6 py-24 text-center fade-up" data-testid="gap-draft-page">
        {state.phase === "working" && (
          <div data-testid="gap-draft-working">
            <Loader2 className="h-10 w-10 text-pinkb mx-auto animate-spin" />
            <h1 className="font-serif uppercase text-3xl text-navy mt-4">Writing your draft…</h1>
            <p className="text-muted-foreground mt-3">This takes about 20 seconds. Keep this page open.</p>
          </div>
        )}
        {state.phase === "done" && (
          <div data-testid="gap-draft-done">
            <CheckCircle2 className="h-10 w-10 text-leaf mx-auto" />
            <h1 className="font-serif uppercase text-3xl text-navy mt-4">{state.status === "already_drafted" ? "Already drafted." : "Draft ready."}</h1>
            {state.title && <p className="mt-3 font-medium" data-testid="gap-draft-title">{state.title}</p>}
            <p className="text-muted-foreground mt-3">For the question: &ldquo;{state.question}&rdquo;. It's saved as a draft, so the AI won't use it until you publish it.</p>
            <Link to="/admin/kb" data-testid="gap-draft-review-link" className="inline-block mt-8 rounded-full bg-navy text-white px-6 py-2.5 text-sm hover:bg-navy/90 transition-colors">Review it in the knowledge bank</Link>
          </div>
        )}
        {state.phase === "error" && (
          <div data-testid="gap-draft-error">
            <AlertTriangle className="h-10 w-10 text-rose-600 mx-auto" />
            <h1 className="font-serif uppercase text-3xl text-navy mt-4">That didn't work.</h1>
            <p className="text-muted-foreground mt-3">{state.message}</p>
            <Link to="/admin/reports" data-testid="gap-draft-reports-link" className="inline-block mt-8 text-pinkb hover:underline text-sm">Open Reports instead</Link>
          </div>
        )}
      </main>
    </div>
  );
}
